import { Dispatch, useEffect, useState } from "react"
import { DialogInfoContext } from "@/types/dialog"
import { UnknownAction } from "@reduxjs/toolkit"

import { closeDialogInfo, openDialogInfo } from "@/lib/storage/dialog-slice"
import { useAppDispatch } from "@/lib/storage/hooks"

const showDialogInfo = (dialogInput: DialogInfoContext) => {
  contexts.push(dialogInput)
  if (contexts.length > 0 && dispatch && setter) {
    const context = {
      ...contexts[contexts.length - 1],
      cancelAction: cancelInterceptAction,
      okAction: okInterceptAction,
    }
    setter(context)
    dispatch(openDialogInfo())
  }
}

const cancelInterceptAction = () => {
  let ret
  const lastIndex = contexts.length > 0 ? contexts.length - 1 : -1
  if (lastIndex >= 0) {
    const cancelCallback = contexts[lastIndex].cancelAction
    if (cancelCallback) {
      ret = cancelCallback()
    }
    if (ret == null || ret.status === "ok") {
      popLastContext(lastIndex)
    }
  }
}

const okInterceptAction = () => {
  let ret
  const lastIndex = contexts.length > 0 ? contexts.length - 1 : -1
  if (lastIndex >= 0) {
    const okCallback = contexts[lastIndex].okAction
    if (okCallback) {
      ret = okCallback()
    }
    if (ret == null || ret.status === "ok") {
      popLastContext(lastIndex)
    }
  }
}

const popLastContext = (lastIndex: number) => {
  if (dispatch && setter) {
    contexts.splice(lastIndex, 1)
    lastIndex = lastIndex - 1
    if (lastIndex >= 0) {
      const context = {
        ...contexts[lastIndex],
        cancelAction: cancelInterceptAction,
        okAction: okInterceptAction,
      }
      setter(context)
      setTimeout(() => {
        dispatch?.(openDialogInfo())
      }, 200) // Let the old dialog closed, then display
    } else {
      dispatch(closeDialogInfo())
    }
  }
}

// Handle multiple dialog nesting.  Save the dialog context
const contexts: Array<DialogInfoContext> = []
let setter: ((state: DialogInfoContext) => void) | undefined
let dispatch: Dispatch<UnknownAction> | undefined

function useDialogInfo() {
  const [state, setState] = useState<DialogInfoContext>()
  const myDispatch = useAppDispatch()
  useEffect(() => {
    setter = setState
    dispatch = myDispatch
    return () => {
      setter = undefined
      dispatch = undefined
    }
  }, [state, myDispatch])

  return state
}

export { showDialogInfo, useDialogInfo }
